/**
 * Different types of AvatarGroupType.
 * @public
 */
enum AvatarGroupType {
	/**
	 * The avatars are displayed as partially overlapped on top of each other and the entire group has one click or tap area.
	 * @public
	 */
	Group = "Group",

	/**
	 * The avatars are displayed side-by-side and each avatar has its own click or tap area.
	 * @public
	 */
	Individual = "Individual",
}

export default AvatarGroupType;
